import { getCoreDataSecurityStatusSlice } from './get';
import { postDataSecurityStatus } from '@api/data-security';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityStatusSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			getCoreDataSecurityStatusSlice.asyncActionCreators.repeatGetCoreDataSecurityStatus
		]
	},
	name: 'CoreDataSecurityStatus',
	receive: false,
	request: true,
	requestHandler: postDataSecurityStatus,
	yieldType: SagaYieldType.Latest
});
